import axiosInstance from "../utils/ApiUtils/axiosInstance";

export type IntegrateServicePackTranslationForm = {
  translationId: number;
  productMajorVersion: string;
};

export const integrateServicePackTranslation = async (data: IntegrateServicePackTranslationForm): Promise<void> => {
  await axiosInstance.post<ApiResponse<null>>(`/api/translation/integrate-service-pack-translation`, data);
};
